import { useMutation } from 'react-query';
import { client } from '@frontend/features/common/services';
import { SendTemplateDto } from '@bandido/shared/types';

export const useSendTemplate = (agencyId?: number | null, caseId?: number) =>
  useMutation((payload: SendTemplateDto) => {
    if (!agencyId) {
      return Promise.reject(new Error('Agency ID is required'));
    }
    return client.post(`whatsapp/send-template/${agencyId}`, payload, { params: caseId ? { caseId } : undefined });
  });
